<div class="progress loop" [class.visible]="loading"></div>
<router-outlet></router-outlet>
<fbr-overlay-host></fbr-overlay-host>
